module.exports = __webpack_public_path__ + "static/media/avatar-7.759dd459.svg";